import React, { useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalTindakLanjutST = ({ showTlSt, handleCloseTlSt, dataDisposisi, dataPrimer, reloadList, isEdit }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)
    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listKesimpulanByIdDisposisi(dataDisposisi?.idDisposisi)
        return {
            options: response.data,
        }
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let jsonDisposisi
            if (valueKesimpulanOpt.idKesimpulan === 6) {
                jsonDisposisi = {
                    nomorAju: dataPrimer.nomorAju,
                    noTugas: 'BTL-' + dataPrimer.nomorAju,
                    tglTugas: new Date(),
                    idDisposisi: valueKesimpulanOpt.idDisposisiNext,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuPenugasan(jsonDisposisi)
            } else if (valueKesimpulanOpt.idKesimpulan === 7) {
                const [idDisp3, idDisp4] = valueKesimpulanOpt.idDisposisiNext.split(",").map(Number)
                jsonDisposisi = {
                    nomorAju: dataPrimer.nomorAju,
                    idDisposisi: idDisp3,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuPenugasan(jsonDisposisi)
                jsonDisposisi = {
                    nomorAju: dataPrimer.nomorAju,
                    idDisposisi: idDisp4,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuPenugasan(jsonDisposisi)
            }

            let jsonStatus = {
                nomorAju: dataPrimer.nomorAju,
                kodeStatus: valueKesimpulanOpt.kdStatusNext,
                waktuStatus: new Date(),
                createdBy: localStorage.getItem("userId"),
                createdDate: new Date()
            }

            await pbumkuService.saveUmkuStatus(jsonStatus)

            let dataHeader = await pbumkuService.getUmkuHeader(dataPrimer.nomorAju)

            let jsonUmkuHeader = {
                ...dataHeader?.data,
                kodeStatus: valueKesimpulanOpt.kdStatusNext
            }
            await pbumkuService.saveUmkuHeader(jsonUmkuHeader)

            setShowConfirmProses(false)
            setShowProsesSuccess(true)

        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }


    return (
        <>
            <Modal
                show={showTlSt}
                onHide={handleCloseTlSt}
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Tindak Lanjut Surat Tugas</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tindak Lanjut</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionKesimpulan}
                                            value={valueKesimpulanOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeKesimpulan}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()} >Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseTlSt}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalTindakLanjutST